import asyncActionTypes from '../actions/types.js';

const initialState = {
  emailFormDataLoading: false,
  emailFormDataSuccess: false,
  emailFormDataFail: false,
  emails: null,
};

const sendEmailItinerary = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.START:
      return {
        ...state,
        emailFormDataLoading: true,
        emailFormDataSuccess: false,
        emailFormDataFail: false,
      };
    case asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.SUCCESS:
      return {
        ...state,
        emailFormDataLoading: false,
        emailFormDataSuccess: true,
      };
    case asyncActionTypes.SEND_EMAIL_ITINERARY_REQUEST.FAIL:
      return {
        ...state,
        emailFormDataLoading: false,
        emailFormDataFail: true,
      };
    case asyncActionTypes.SET_EMAIL_ITINERARY:
      return {
        ...state,
        emailFormDataSuccess: false,
        emailFormDataFail: false,
      };
    default:
      return state;
  }
};

export default sendEmailItinerary;
